import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_home/meter-connection-settings/commodity-rates/',
)({
  component: CommodityRatesPage,
})

function CommodityRatesPage() {
  return <div>Commodity Rates</div>;
}
